import infosite from './infosite';

export default function infositeRoundTour(config) {
	return infosite({...config, isRoundTour: true});
}
